import * as React from 'react';
import { Navigate } from 'react-router-dom';
import ManageUsersHub from '../../components/user_management/ManageUsersHub';
import { UserContext } from '../../context/UserContext';
import LoadingScreen from '../../components/shared/loading/LoadingScreen';
import { getAdminGroups } from '../../util/user_access';
import { default_authenticated_home_url } from '../../components/routing/Routes';
import { useModuleDurationTracking } from '../../hooks/useModuleDurationTracking';

const UserManagementView = () => {
  // Track module duration.
  useModuleDurationTracking('User Management', 'N/A');

  const { user } = React.useContext(UserContext);
  // Only super admins and group admins may manage users. Anyone else who
  // reaches this route (e.g. via a bookmark or direct URL) is redirected home
  // rather than shown a dead-end; `replace` keeps the guarded route out of
  // history so the back button doesn't bounce them straight back here.
  return user === null ? (
    <LoadingScreen />
  ) : user.super_admin || getAdminGroups(user).length > 0 ? (
    <ManageUsersHub></ManageUsersHub>
  ) : (
    <Navigate to={default_authenticated_home_url} replace />
  );
};

export default UserManagementView;
